import { removeStorage, setStorage } from "_metronic/utils/utils";

import { actionTypes as authActionTypes } from "app/store/modules/actions/auth.actions";
import { actionTypes } from "app/store/modules/actions/workspaces.actions";

export const ACTIVE_WORKSPACE_STORAGE_KEY = "active-workspace-id:v1";

const initialState = {
  available: [],
  activeWorkspaceId: null,
  activeWorkspace: null,
  bootstrapStatus: "idle",
  bootstrapError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BOOTSTRAP_STARTED:
      return { ...state, bootstrapStatus: "loading", bootstrapError: null };
    case actionTypes.WORKSPACES_LOADED:
      return { ...state, available: action.payload };
    case actionTypes.WORKSPACE_SELECTED: {
      const activeWorkspaceId = action.payload;
      setStorage(ACTIVE_WORKSPACE_STORAGE_KEY, activeWorkspaceId);
      return { ...state, activeWorkspaceId, bootstrapStatus: "loading", bootstrapError: null };
    }
    case actionTypes.WORKSPACE_DETAILS_LOADED: {
      const workspace = action.payload;
      return {
        ...state,
        activeWorkspace: workspace,
        bootstrapStatus: "ready",
        bootstrapError: null,
      };
    }
    case actionTypes.BOOTSTRAP_EMPTY:
      removeStorage(ACTIVE_WORKSPACE_STORAGE_KEY);
      return {
        ...state,
        activeWorkspaceId: null,
        activeWorkspace: null,
        bootstrapStatus: "empty",
      };
    case actionTypes.BOOTSTRAP_FAILED:
      return { ...state, bootstrapStatus: "error", bootstrapError: action.payload };
    case actionTypes.WORKSPACE_MEMBERSHIP_UPDATED:
      return {
        ...state,
        available: state.available.map((workspace) =>
          workspace.workspaceId === action.payload.workspaceId
            ? { ...workspace, ...action.payload.changes }
            : workspace
        ),
      };
    case authActionTypes.Logout:
    case actionTypes.CLEAR_WORKSPACES:
      removeStorage(ACTIVE_WORKSPACE_STORAGE_KEY);
      return initialState;
    default:
      return state;
  }
};
